// 会社概要ロゴをキャッシュし、ページ遷移時に古いロゴが一瞬表示されるのを防ぐ。
const CACHED_LOGO_KEY = 'presage_logo_url';
const DEFAULT_LOGO = '/uploads/logo-static.png';

export const getCachedLogo = () => {
  try {
    return localStorage.getItem(CACHED_LOGO_KEY) || DEFAULT_LOGO;
  } catch (e) {
    return DEFAULT_LOGO;
  }
};

export const cacheLogo = (url) => {
  try {
    if (url) localStorage.setItem(CACHED_LOGO_KEY, url);
  } catch (e) {
    // ignore
  }
};
